import { Controller, useForm } from 'react-hook-form';

import { useGanttSettingsStore } from 'store/ganttSettings.store';

import { Button } from 'components/DesignSystem/Button';
import { Modal } from 'components/DesignSystem/Modal';
import { Select } from 'components/DesignSystem/Select';
import { Switch } from 'components/DesignSystem/Switch';
import classes from 'components/widgets/Gantt/components/ganttSettingsModal.module.scss';

const calendarViewRangeOptions: ISelectOption<string>[] = [
    {
        label: 'Month & Year',
        value: 'monthAndYear',
    },
    {
        label: 'Quarter & Year',
        value: 'year',
    },
    {
        label: 'Years',
        value: 'manyYears',
    },
];

export const GanttSettingsModal = ({ showModal, onHideModal }) => {
    const { calendarViewRange, showActivityLabels, showProgressLine, update, showBaseline, showDependencies } =
        useGanttSettingsStore();
    const { handleSubmit, control } = useForm<any>({
        values: {
            calendarViewRange: calendarViewRangeOptions.find((item) => item.value === calendarViewRange),
            showActivityLabels,
            showProgressLine,
            showBaseline,
            showDependencies,
        },
    });

    const handleSave = (data) => {
        update({ ...data, calendarViewRange: data.calendarViewRange.value });
        onHideModal();
    };

    return (
        <Modal
            open={showModal}
            onClose={onHideModal}
            title={'Gantt settings'}
            actions={
                <>
                    <Button size={'large'} variant={'secondary'} onClick={onHideModal}>
                        Cancel
                    </Button>

                    <Button size={'large'} variant={'primary'} type={'submit'} onClick={handleSubmit(handleSave)}>
                        Save
                    </Button>
                </>
            }
        >
            <form onSubmit={handleSubmit(handleSave)}>
                <div className={classes.content}>
                    <div className={classes.row}>
                        <label>Calendar view range</label>
                        <Controller
                            render={({ field }) => (
                                <Select<ISelectOption<string>> {...field} options={calendarViewRangeOptions} />
                            )}
                            name={'calendarViewRange'}
                            control={control}
                        />
                    </div>
                    <div className={classes.row}>
                        <label>Show baseline</label>
                        <Controller
                            render={({ field }) => <Switch {...field} checked={field.value} />}
                            name={'showBaseline'}
                            control={control}
                        ></Controller>
                    </div>
                    <div className={classes.row}>
                        <label>Show activity labels</label>
                        <Controller
                            render={({ field }) => <Switch {...field} checked={field.value} />}
                            name={'showActivityLabels'}
                            control={control}
                        ></Controller>
                    </div>
                    <div className={classes.row}>
                        <label>Show progress line</label>
                        <Controller
                            render={({ field }) => <Switch {...field} checked={field.value} />}
                            name={'showProgressLine'}
                            control={control}
                        ></Controller>
                    </div>
                    <div className={classes.row}>
                        <label>Show dependencies</label>
                        <Controller
                            render={({ field }) => <Switch {...field} checked={field.value} />}
                            name={'showDependencies'}
                            control={control}
                        ></Controller>
                    </div>
                </div>
            </form>
        </Modal>
    );
};
